import React from "react";
import axios from "axios";
import PropTypes from "prop-types";
import Icon from "./Icons";
import { ajaxUri } from "../consts/index";
import { l } from "../functions";
import GKEvent from "../events";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import imageCompressor from "browser-image-compression";

class ReactImageUploadComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      picture: props.defaultImages,
      pictureName:
        props.defaultImages.split("/")[
          props.defaultImages.split("/").length - 1
        ],
      pictureInfosDimension: "",
      file: "",
      notAcceptedFileType: [],
      notAcceptedFileSize: [],
      uploading: false,
    };
    this.inputElement = "";
    this.onDropFile = this.onDropFile.bind(this);
    this.onUploadClick = this.onUploadClick.bind(this);
    this.triggerFileUpload = this.triggerFileUpload.bind(this);
  }

  // Check file extension (onDropFile)
  hasExtension(fileName) {
    const pattern =
      "(" + this.props.imgExtension.join("|").replace(/\./g, "\\.") + ")$";
    return new RegExp(pattern, "i").test(fileName);
  }

  componentWillReceiveProps({ defaultImages }) {
    if (defaultImages !== this.props.defaultImages)
      this.setState({
        picture: defaultImages,
        pictureName:
          defaultImages.split("/")[defaultImages.split("/").length - 1],
      });
  }

  /*
	Handle file validation
	*/
  async onDropFile(e) {
    const files = e.target.files;
    const allFilePromises = [];
    this.setState({ loading: true });
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };

    let compressedFile = null;

    // Iterate over all uploaded files
    for (let i = 0; i < files.length; i++) {
      let f = files[i];
      // Check for file extension
      if (!this.hasExtension(f.name)) {
        const newArray = this.state.notAcceptedFileType.slice();
        newArray.push(f.name);
        this.setState({ notAcceptedFileType: newArray });
        continue;
      }
      // Check for file size
      if (f.size > this.props.maxFileSize) {
        const newArray = this.state.notAcceptedFileSize.slice();
        newArray.push(f.name);
        this.setState({ notAcceptedFileSize: newArray });
        continue;
      }

      if (this.props.cartIcon) {
        options.maxWidthOrHeight = 50;
      }

      let fileName = f?.name.replace(/\s+/g, "-");
      fileName = fileName?.replace(/[&\/\\#,+()$~%'":*?<>{}]/g, "-");

      console.log("file-name", fileName);

      try {
        compressedFile = await imageCompressor(f, options);
        compressedFile.name = f?.name;
        console.log(compressedFile.size);
        allFilePromises.push(this.readFile(compressedFile));
      } catch (e) {
        console.log(e);
      }
    }

    Promise.all(allFilePromises).then((newFilesData) => {
      let fileBase64 = "";
      let fileFile = "";

      newFilesData.forEach((newFileData) => {
        fileBase64 = newFileData.dataURL;
        fileFile = newFileData.file;
      });

      // console.log(fileBase64);

      this.setState(
        {
          picture: l("Uploading..."),
          file: fileFile,
        },
        () => {
          if (fileBase64) {
            axios({
              method: "post",
              url: ajaxUri,
              data: {
                request: "uploadImage",
                image: fileBase64,
              },
            })
              .then((result) => {
                this.setState(
                  {
                    loading: false,
                  },
                  () => {
                    if (result.data && result.data.path) {
                      this.setState({
                        picture: result.data.path,
                      });
                      this.props.onChange(result.data.path);
                    } else {
                      GKEvent.notification(
                        "error",
                        l(
                          "Error while uploading image. Please try again, or rename the file."
                        )
                      );
                      this.setState({
                        picture: this.props.defaultImages,
                      });
                    }
                  }
                );
              })
              .catch((error) => {
                GKEvent.notification(
                  "error",
                  l(
                    "Error while uploading image. Please try again, or rename the file."
                  )
                );
              });
          }
        }
      );
    });
  }

  onUploadClick(e) {
    e.target.value = null;
  }

  // Read a file and return a promise that when resolved gives the file itself and the data URL
  readFile(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      // Read the image via FileReader API and save image result in state.
      reader.onload = function (e) {
        // Add the file name to the data URL
        let dataURL = e.target.result;
        dataURL = dataURL.replace(";base64", `;name=${file.name};base64`);
        resolve({ file, dataURL });
      };

      reader.readAsDataURL(file);
    });
  }

  // Remove the image from state
  removeImage() {
    this.setState({ picture: "", file: "" }, () => {
      this.props.onChange("");
    });
  }

  // Check if any errors && render
  renderErrors() {
    let notAccepted = "";
    if (this.state.notAcceptedFileType.length > 0) {
      notAccepted = this.state.notAcceptedFileType.map((error, index) => {
        return (
          <div
            className={"gk-error-message " + this.props.errorClass}
            key={index}
            style={this.props.errorStyle}
          >
            * {error} {this.props.fileTypeError}
          </div>
        );
      });
    }
    if (this.state.notAcceptedFileSize.length > 0) {
      notAccepted = this.state.notAcceptedFileSize.map((error, index) => {
        return (
          <div
            className={"gk-error-message " + this.props.errorClass}
            key={index}
            style={this.props.errorStyle}
          >
            * {error} {this.props.fileSizeError}
          </div>
        );
      });
    }
    return notAccepted;
  }

  // On button click, trigger input file to open
  triggerFileUpload() {
    this.inputElement.click();
  }

  getImageMeta = () => {
    var img = new Image();
    const scope = this;

    img.onload = function () {
      if (scope.state.pictureInfosDimension == "")
        scope.setState({
          pictureInfosDimension: this.width + " x " + this.height + "px",
        });
    };

    img.src = this.state.picture;
  };

  generatePreview = () => {
    if (this.state.loading)
      return <div className="gk-loader">{l("loading")}</div>;

    if (this.state.picture) {
      this.getImageMeta(this.state.picture);
      return (
        <img src={this.state.picture} className="uploadPicture" alt="preview" />
      );
    }

    return <Icon icon="picture" />;
  };

  render() {
    if (this.props.quickbar) {
      return (
        <div
          className="gk-imageuploader"
          style={{
            marginTop: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {this.renderErrors()}

          <button
            type={this.props.buttonType}
            onClick={this.triggerFileUpload}
            style={{
              marginTop: 0,
            }}
          >
            {this.props.buttonText}
            {this.state?.loading ? (
              <span className="quickbar-loader" />
            ) : (
              <FontAwesomeIcon icon={["fas", "upload"]} />
            )}
          </button>
          <input
            type="file"
            ref={(input) => (this.inputElement = input)}
            name={this.props.name}
            multiple={!this.props.singleImage}
            onChange={this.onDropFile}
            onClick={this.onUploadClick}
            accept={this.props.accept}
          />
        </div>
      );
    }
    return (
      <div className="gk-imageuploader">
        {this.renderErrors()}
        {this.props.title && <h3 className="gk-title">{this.props.title}</h3>}
        <div className="gk-imagedetails">
          <div className={`gk-preview ${this.state.picture ? "" : "empty"}`}>
            {this.generatePreview()}
          </div>
          <div className="gk-details">
            {this.state.pictureName && (
              <div>
                <p>{this.state.pictureName}</p>
                <p>{this.state.pictureInfosDimension}</p>
              </div>
            )}
            {this.state.picture && (
              <div className="gk-delete">
                <Icon onClick={() => this.removeImage()} icon={"trash"} />
              </div>
            )}
          </div>
        </div>
        {
          // (this.props.singleImage && Object.keys(this.state.picture).length == 0 || !this.props.singleImage ) && <button
          !this.state.picture && (
            <button
              type={this.props.buttonType}
              onClick={this.triggerFileUpload}
            >
              {this.props.buttonText}
            </button>
          )
        }
        <input
          type="file"
          ref={(input) => (this.inputElement = input)}
          name={this.props.name}
          multiple={!this.props.singleImage}
          onChange={this.onDropFile}
          onClick={this.onUploadClick}
          accept={this.props.accept}
        />
      </div>
    );
  }
}

ReactImageUploadComponent.defaultProps = {
  className: "",
  fileContainerStyle: {},
  buttonClassName: "",
  buttonStyles: {},
  withPreview: false,
  accept: "image/*",
  name: "",
  withIcon: true,
  buttonText: "Choose images",
  buttonType: "button",
  withLabel: true,
  label: "Max file size: 5mb, accepted: jpg | gif | png | webp",
  labelStyles: {},
  labelClass: "",
  imgExtension: [".jpg", ".jpeg", ".gif", ".png", ".webp"],
  maxFileSize: 5242880,
  fileSizeError: " file size is too big",
  fileTypeError: " is not a supported file extension",
  errorClass: "",
  style: {},
  errorStyle: {},
  singleImage: false,
  onChange: () => {},
  defaultImages: "",
  quickbar: false,
};

ReactImageUploadComponent.propTypes = {
  style: PropTypes.object,
  fileContainerStyle: PropTypes.object,
  className: PropTypes.string,
  onChange: PropTypes.func,
  onDelete: PropTypes.func,
  buttonClassName: PropTypes.string,
  buttonStyles: PropTypes.object,
  buttonType: PropTypes.string,
  withPreview: PropTypes.bool,
  accept: PropTypes.string,
  name: PropTypes.string,
  withIcon: PropTypes.bool,
  buttonText: PropTypes.string,
  withLabel: PropTypes.bool,
  label: PropTypes.string,
  labelStyles: PropTypes.object,
  labelClass: PropTypes.string,
  imgExtension: PropTypes.array,
  maxFileSize: PropTypes.number,
  fileSizeError: PropTypes.string,
  fileTypeError: PropTypes.string,
  errorClass: PropTypes.string,
  errorStyle: PropTypes.object,
  singleImage: PropTypes.bool,
  defaultImages: PropTypes.string,
};

export default ReactImageUploadComponent;
